module.exports = __webpack_public_path__ + "public/SideMenuIcons/completeBookings.svg?3c346632";